import { useAxios } from "../../../../hooks/useAxios"
import { AutorizacionesAdapters } from "../adapters/autorizaciones.adapters"

// Usuarios autorizados de una empresa. Usa la API de Laravel (misma base que el
// módulo de empresas), por eso se llama con `useAxios` en lugar de `useIntegraWeb`.
const AutorizacionesServices = {

    // GET /integra-web/empresas/usuarios-autorizados/{empresaId}
    // Listado con filtro por texto (`search`) y por estado (`estado`).
    GET_USUARIOS_AUTORIZADOS: function () {

        return useAxios({
            method: 'get',
            url: '/integra-web/empresas/usuarios-autorizados',
            type: 'json',
            adapters: AutorizacionesAdapters.GET_USUARIOS_AUTORIZADOS
        })
    },

    // GET /integra-web/empresas/usuarios-autorizados/buscar
    // Candidatos a autorizar (los `id` se pasan como query param, no en la url).
    GET_BUSCAR_PARA_AUTORIZAR: function () {

        return useAxios({
            method: 'get',
            url: '/integra-web/empresas/usuarios-autorizados/buscar',
            type: 'json',
            adapters: AutorizacionesAdapters.GET_BUSCAR_PARA_AUTORIZAR
        })
    },

    // POST /integra-web/empresas/usuarios-autorizados
    // Alta de autorización directa (sin correo).
    POST_AUTORIZAR_USUARIO: function () {

        return useAxios({
            method: 'post',
            url: '/integra-web/empresas/usuarios-autorizados',
            type: 'json',
            adapters: AutorizacionesAdapters.POST_AUTORIZAR_USUARIO
        })
    },

    // DELETE /integra-web/empresas/usuarios-autorizados/{id}
    // Baja de una autorización por su id de registro.
    DELETE_USUARIO_AUTORIZADO: function () {

        return useAxios({
            method: 'delete',
            url: '/integra-web/empresas/usuarios-autorizados',
            type: 'json',
            adapters: AutorizacionesAdapters.DELETE_USUARIO_AUTORIZADO
        })
    },
}

export {
    AutorizacionesServices
}
